var _defs, _style, _filter, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 608 12",
    width: 608,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dots-design-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h608v12h-608z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #f5f5f5 } \n\t")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "f0"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f9f9f9",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)",
    filter: "url(#f0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m10.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m36 23c-5.5 0-10-5.1-10-11.5 0-6.4 4.5-11.5 10-11.5 5.5 0 10 5.1 10 11.5 0 6.4-4.5 11.5-10 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m61.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m87 23c-5.5 0-10-5.1-10-11.5 0-6.4 4.5-11.5 10-11.5 5.5 0 10 5.1 10 11.5 0 6.4-4.5 11.5-10 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m112.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m138 23c-5.5 0-10-5.1-10-11.5 0-6.4 4.5-11.5 10-11.5 5.5 0 10 5.1 10 11.5 0 6.4-4.5 11.5-10 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m163.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m189 23c-5.5 0-10-5.1-10-11.5 0-6.4 4.5-11.5 10-11.5 5.5 0 10 5.1 10 11.5 0 6.4-4.5 11.5-10 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m214.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m240 23c-5.5 0-10-5.1-10-11.5 0-6.4 4.5-11.5 10-11.5 5.5 0 10 5.1 10 11.5 0 6.4-4.5 11.5-10 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m265.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m291.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m316.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m342.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m368 23c-5.5 0-10-5.1-10-11.5 0-6.4 4.5-11.5 10-11.5 5.5 0 10 5.1 10 11.5 0 6.4-4.5 11.5-10 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m393.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m419 23c-5.5 0-10-5.1-10-11.5 0-6.4 4.5-11.5 10-11.5 5.5 0 10 5.1 10 11.5 0 6.4-4.5 11.5-10 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m444.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m470 23c-5.5 0-10-5.1-10-11.5 0-6.4 4.5-11.5 10-11.5 5.5 0 10 5.1 10 11.5 0 6.4-4.5 11.5-10 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m495.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m521 23c-5.5 0-10-5.1-10-11.5 0-6.4 4.5-11.5 10-11.5 5.5 0 10 5.1 10 11.5 0 6.4-4.5 11.5-10 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m546.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m572 23c-5.5 0-10-5.1-10-11.5 0-6.4 4.5-11.5 10-11.5 5.5 0 10 5.1 10 11.5 0 6.4-4.5 11.5-10 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m597.5 23c-5.8 0-10.5-5.1-10.5-11.5 0-6.4 4.7-11.5 10.5-11.5 5.8 0 10.5 5.1 10.5 11.5 0 6.4-4.7 11.5-10.5 11.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsDesign);
export default __webpack_public_path__ + "static/media/dots-design.aa82773b9ab1164b56293c417d4e74ae.svg";
export { ForwardRef as ReactComponent };